import moment, { Moment } from 'moment';

export const getStartOrEndDateByDateAndDuration = (date: Moment, duration: number, type: 'start' | 'end'): Moment => {
  let durationInMs = duration * 1000 * 24 * 3600;
  durationInMs = type === 'start' ? durationInMs * -1 : durationInMs;
  return moment(date.valueOf() + durationInMs);
};
